class PromiseDirective
  @$inject: ["$q"]  
  scope:
    "click": "&promiseClick"
  constructor: ($q)->
    class Promise      
      restrict: "A"
      scope:
        "click": "&promiseClick"
      link: (scope, element, attrs)->          
        element.on 'click', ()=>          
          @execute scope, element, 'click'

      execute: (scope, element, event)->
        if scope[event]          
          element.prop "disabled", true
          element.removeClass "loading"
          element.addClass "loading"
          result = scope[event]()
          promise = switch
            when result?.finally then result
            else $q.resolve()
          promise.finally ()=>
            @cleanup(element)
            
      cleanup: (element)->
        element.removeClass "loading"
        element.prop "disabled", false          

    return new Promise()

angular = require('angular')
pkg = angular
  .module 'common.promise', []
  .directive "promise", PromiseDirective
  
module.exports = pkg.name


// WEBPACK FOOTER //
// ./src/common/promise/index.coffee